import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}payroll/meta-conversion/`;

export default {
  preview(period) {
    return axios.get(`${API_URL}preview`, {
      params: { period },
      headers: buildHeaders(),
    });
  },

  commit(payload) {
    return axios.post(`${API_URL}commit`, payload, {
      headers: buildHeaders(),
    });
  },
};
